import { IFramework, IWebServiceManager, HttpMethod, IUserContext } from '@truckdown/framework';
import { IRestrictionManager } from './IRestrictionManager';
import { ClientRestrictionStatus } from './Models/ClientRestrictionStatus';
import { GetRestrictionsModel } from './Models/GetRestrictionsModel';
import { Restriction } from './Models/Restriction';
import { UpdateRestrictionModel } from './Models/UpdateRestrictionModel';
import { ResultModel } from './ResultModel';

export class RestrictionManager implements IRestrictionManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly errorMsg: string = 'Error in restrictions manager request';
    private readonly basePath: string = '/tools/throttling/restrictions';

    enableCaptcha(key: string, note: string, expiry?: Date): Promise<Restriction | null> {
        let model = {
            key: key,
            note: note,
            expiry: expiry
        };

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/captcha',
            method: HttpMethod.PUT
        }, model);

        return this.manager
            .get<any>(req)
            .then((res) => {
                if (res == null) {
                    return null;
                }
                return new Restriction(res);
            });
    }

    updateRestriction(model: UpdateRestrictionModel): Promise<Restriction | null> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath,
            method: HttpMethod.PUT
        }, model);

        return this.manager
            .get<any>(req)
            .then((res) => {
                if (res == null) {
                    return null;
                }
                return new Restriction(res);
            });
    }

    async delete(key: string): Promise<void> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(key),
            method: HttpMethod.DELETE
        });

        var res = await this.manager.send(req);
        if (!res.ok) {
            console.log(this.errorMsg, req, res);
            throw new Error(this.errorMsg);
        }
    }

    async getStatus(key: IUserContext | string) {
        let setKey = (typeof key === 'string' || key instanceof String)
            ? key as string
            : (key as IUserContext).user?.id ?? 'self';

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/' + encodeURIComponent(setKey),
            method: HttpMethod.GET
        });

        var res = await this.manager
            .get<ResultModel<ClientRestrictionStatus>>(req);
        return res.res;
    }

    async getRestrictionsCount(model: GetRestrictionsModel) {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + '/count',
            method: HttpMethod.POST
        }, model);

        var res = await this.manager
            .get<ResultModel<number>>(req);
        return res.res;
    }

    getRestrictions(model: GetRestrictionsModel): Promise<Restriction[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath,
            method: HttpMethod.POST
        }, model);

        return this.manager
            .get<any[]>(req)
            .then((res) => {
                return res.map((v, idx, arr) => {
                    return new Restriction(v);
                });
            });
    }

}